import state from './../zviz2/zviz/state';
import {proxy} from './../zviz2/zviz/functions';
import {Analytics} from '../helpers/analytics/index.js';
import config from '../config.js';

class GoogleAnalytics{

    constructor(){


        this.names = ['source', 'view', 'filter.region', 'filter.country',
                'filter.theme_category', 'filter.theme', 'list.details_id'];
        this.values = {};

        for(let name of this.names){
            state.addResponder(name, [this, this.track]);
            this.values[name] = null;
        }

        this.timerId = null;
        this.currentPage = '/';

        this.trackPage();   // initial page tracking
        
    }

    track(){
        clearTimeout(this.timerId);
        this.timerId = setTimeout(proxy([this, this.trackEvent]), 1500);
    }

    trackPage(){
        let page = '/' + state.get('source');
        page += '/' + state.get('view');
        let projId = state.get('list.details_id');
        if(projId && projId != ''){
            page += '/' + projId;
        }
        // Track only when the page has changed
        if(page != this.currentPage){
            this.currentPage = page;
            // const parts = config.root.split('/').filter((p) => (p != ''));
            // const applicationPath = parts.length > 0 ? parts[parts.length - 1] : '';
            // // window.location.origin
            // const location = 'http://localhost:3000' + '/' + applicationPath + page;
            Analytics.trackPageView({title: page, path: page});
        }
    }

    trackEvent(){
        if(window.dataLayer){

            this.trackPage();

            for(let name of this.names){
                let value = state.get(name);
                if(value instanceof Array){
                    value = value.join(', ');
                }
                // only track when the value has changed
                if(value && this.values[name] != value){
                    this.values[name] = value;
                    if(name != 'source' || name != 'view' || name != 'list.details_id'){
                        let parts = name.split('.');
                        let cat = parts[0];
                        let action = parts.length>1? parts.slice(1).join('.'): cat;
                        Analytics.trackEvent({
                            action: action,
                            category: cat,
                            label: value

                        })
                    }

                }
            }
        }
    }

}

export default GoogleAnalytics;